import { createReducer } from 'redux-act';
import * as action from '../actions/epicIntegration.actions';

export const initialState = {
  isEpicDataFetched: false,
  isEpicDataFetchFailed: null,
};

const epicIntegrationReducer = createReducer(
  {
    [action.fetchEpicDataSuccess]: (state, payload) => {
      return {
        ...state,
        isEpicDataFetched: !!payload,
      };
    },
    [action.fetchEpicDataFail]: (state, error) => {
      return {
        ...state,
        isEpicDataFetchFailed: !!error,
      };
    },
  },
  initialState,
);

export default epicIntegrationReducer;
